import { useState, useCallback } from 'react'
import { sameCarrier } from '../utils/fuzzyMatchClients'

export const useReferralAutoMatch = ({
  insuranceCompanies = [],
  referralSourceList = [],
  setFormInputValues,
  referralSourceCode = null
}) => {
  const [autoMatchedReferral, setAutoMatchedReferral] = useState(null)
  const [showReferralField, setShowReferralField] = useState(!!referralSourceCode)

  const matchReferral = useCallback(
    (insuranceCompanyId) => {
      const selectedInsurance = insuranceCompanies.find((c) => c.id === insuranceCompanyId)

      // Exact name first; otherwise the same carrier under another spelling ("State Farm Insurance Companies"
      // is the State Farm agreement), so a national agreement is never dropped over a suffix.
      const insurerName = selectedInsurance?.name
      const matchedReferral = insurerName
        ? (referralSourceList.find((r) => r.value?.toLowerCase() === insurerName.toLowerCase()) ??
          referralSourceList.find((r) => sameCarrier(r.value, insurerName)))
        : undefined

      if (matchedReferral) {
        setAutoMatchedReferral(matchedReferral)
        // setShowReferralField(true)
        setFormInputValues((prev) => ({
          ...prev,
          referral_source_code: matchedReferral.id
        }))
      } else {
        setAutoMatchedReferral(null)
        setFormInputValues((prev) => ({
          ...prev,
          referral_source_code: null
        }))
      }
    },
    [insuranceCompanies, referralSourceList, setFormInputValues]
  )

  return {
    autoMatchedReferral,
    setAutoMatchedReferral,
    showReferralField,
    setShowReferralField,
    matchReferral
  }
}
